import { fetcher, useFetch } from "matsuri-hooks";
import { getM2MStorageHubDomain } from "./storage/getM2MStorageHubDomain";
import {
  type DomainRecord,
  productionDomains,
  developmentDomains,
} from "./domains-data";

export * from "./domains-data";

/**
 * 可能なら最新のドメインを取得し、取得出来なければリリース時のドメインを返す。
 * Q. なぜgetDomainsではなくuseDomainsなのか
 * A. M2M_COMPONENTS_ENVが設定される前に、この関数が呼び出されると常にdevelopmentになってしまうため、
 * Reactを利用するケースを考えるとコンポーネントのレンダリング時などに呼んでもらう必要がある。
 * React hookのような命名にしておくことで、Linterによってこれを強制できる。
 */
export const useDomains = (): DomainRecord => {
  const env =
    globalThis.M2M_COMPONENTS_ENV === "production"
      ? "production"
      : "development";
  const domain = getM2MStorageHubDomain(env);
  const { data, error } = useFetch<DomainRecord>(
    `${domain}/api/domains/${env}`,
  );
  if (error || !data) {
    return env === "production" ? productionDomains : developmentDomains;
  }
  return data;
};

export const domainsPromise = async (
  signal?: AbortSignal,
): Promise<DomainRecord> => {
  const env =
    globalThis.M2M_COMPONENTS_ENV === "production"
      ? "production"
      : "development";
  const domain = getM2MStorageHubDomain(env);
  const { data, error } = await fetcher<DomainRecord>(
    `${domain}/api/domains/${env}`,
    {
      // eslint-disable-next-line no-restricted-globals
      fetch: (info, init) => fetch(info, { ...init, signal }),
    },
  );
  if (error || !data) {
    return env === "production" ? productionDomains : developmentDomains;
  }
  return data;
};
